<template>

  <div>
    <!-- Filters -->
    <filters
      :status-filter.sync="statusFilter"
      :discount-type-filter.sync="discountTypeFilter"
      :discount-segment-filter.sync="discountSegmentFilter"
      :discount-usability-filter.sync="discountUsabilityFilter"
    />

    <!-- Table Container Card -->
    <model-list-table
      ref="listTable"
      :store-module-name="storeModuleName"
      :table-columns="tableColumns"
      :filters-list="filtersList"
      :query-params="getQueryParams"
      add-action="sidebar"
      :view-action="false"
      edit-action="sidebar"
      :delete-action="true"
      :extra-actions="[]"
      :sidebar="SidebarAddNewCoupon"
      :is-sortable="false"
    >
      <template #cell(validity)="data">
        <span v-if="!data.item.start_at && !data.item.end_at">
          {{ $t('modules.coupons.columns.no_date_restrictions') }}
        </span>
        <span v-else>
          {{ data.item.start_at ? formatDate(data.item.start_at) : '-' }} → {{ data.item.end_at ? formatDate(data.item.end_at) : '-' }}
        </span>
      </template>
    </model-list-table>
  </div>
</template>

<script>
import store from '@/store'
import { ref, onUnmounted } from 'vue'
import { formatDate } from '@core/utils/filter'
import ModelListTable from '@/views/models/common/ModelListTable.vue'
import SidebarAddNewCoupon from '@/views/models/coupons/add/SidebarAddNewCoupon.vue'
import { VBToggle } from 'bootstrap-vue'
import couponStoreModule from '@/views/models/coupons/couponStoreModule'
import Filters from './Filters.vue'

export default {
  components: {
    Filters,
    ModelListTable,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  methods: { formatDate },
  setup() {
    const STORE_MODULE_NAME = 'coupons'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, couponStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    const statusFilter = ref(null)
    const discountTypeFilter = ref(null)
    const discountSegmentFilter = ref(null)
    const discountUsabilityFilter = ref(null)

    const tableColumns = [
      {
        key: 'draggable',
        label: '',
        sortable: false,
        thClass: 'p-0',
        thStyle: 'width: 1px',
        tdClass: ['p-0', 'pl-1', 'draggable-handle', 'cursor-move'],
      },
      {
        key: 'checkbox',
        label: '',
        sortable: false,
      },
      { key: 'coupon_code', sortable: true, label: 'modules.coupons.s_c' },
      { key: 'discount_value', sortable: true, label: 'modules.coupons.inputs.discount_value' },
      { key: 'discount_usability', sortable: true, label: 'modules.coupons.columns.discount_usability' },
      { key: 'orders_count', sortable: true, label: 'modules.coupons.columns.usage_count' },
      {
        key: 'validity',
        label: 'modules.coupons.columns.validity',
        sortable: false,
      },
      {
        key: 'created_at',
        label: 'Creation Date',
        formatter: formatDate,
        sortable: true,
      },
      {
        key: 'updated_at',
        label: 'Last Update',
        formatter: formatDate,
        sortable: true,
      },
      { key: 'is_active', sortable: true, label: 'Status' },
      { key: 'actions' },
    ]

    const filtersList = [statusFilter, discountTypeFilter, discountSegmentFilter, discountUsabilityFilter]
    const getQueryParams = () => ({
      // categories: categoryFilter.value,
      discount_type: discountTypeFilter.value,
      discount_segment: discountSegmentFilter.value,
      discount_usability: discountUsabilityFilter.value,
      is_active: statusFilter.value,
    })

    return {

      // Extra Filters
      discountTypeFilter,
      discountSegmentFilter,
      discountUsabilityFilter,
      statusFilter,

      // Table props
      tableColumns,
      storeModuleName: STORE_MODULE_NAME,
      filtersList,
      getQueryParams,

      SidebarAddNewCoupon,
      formatDate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">

$gray-300: #dee2e6 !default;
$border-color: $gray-300 !default;

::v-deep .b-table {
  tbody {
    tr {
      //cursor: move;
    }
  }
}

.b-table {
  tbody {
    tr.ready-for-drag {
      transform: translateY(-4px);
      box-shadow: 0 3px 10px 0 $border-color;
      transition: all 0.2s;
    }
    tr {
      &:has(td .draggable-handle) {
        transform: translateY(-4px);
        box-shadow: 0 3px 10px 0 $border-color;
        transition: all 0.2s;
      }
    }
  }
}

.btn-link:hover {
  color: #5d6064 !important;
}
</style>
